<template>
	<div>
		<h2>{{ $t('invoice.sepa_history.titre') }}</h2>
		<div class="box">
			<DateRangeV2
				:start.sync="start_date"
				:end.sync="end_date"
				@submit="loadTransfers"
				:dateSelect="true"
				:periodToShow="['personalise','jour','mois','mois_dernier']"
			/>

			<CustomTable
				ref="table"
				id_table="sepa_transfer"
				:items="transfers"
				:busy.sync="table_busy"
				primaryKey="sepatransfer_id"
				:hide_if_empty="true"
				:externSlotColumns="extern_slot_columns"
			>
				<!-- Un lot reconstitué sans remise retrouvée n'a pas d'identifiant : sa date de génération en tient lieu. -->
				<template v-slot:custom-slot-cell(sepatransfer_msg_id)="{ data }">
					<a href="" @click.prevent="showTransfer(data)">{{ data.sepatransfer_msg_id || data.sepatransfer_generated_at_format }}</a>
				</template>
				<template v-slot:custom-slot-cell(status_label)="{ data }">
					<b-badge :variant="status_variants[data.sepatransfer_status]">{{ data.status_label }}</b-badge>
				</template>
			</CustomTable>
		</div>

		<SepaTransferDetail ref="detail" @change="loadTransfers" />
	</div>
</template>


<script type="text/javascript">
	import CustomTable from "GroomyRoot/components/Table/CustomTable"
	import TableAction from "@/mixins/TableAction.js"
	import Invoice from "@/mixins/Invoice.js"
	import Navigation from "@/mixins/Navigation.js"

	export default {
		name: "InvoiceSupplierSepaTransferHistory",
		mixins: [TableAction, Invoice, Navigation],
		data () {
			return {
				transfers: null,
				table_busy: true,
				extern_slot_columns: ['sepatransfer_msg_id', 'status_label'],
				status_variants: {
					generated: 'warning',
					confirmed: 'info',
					reconciled: 'success',
					cancelled: 'secondary'
				},
				events_tab: {
					'TableAction::goToDownloadSepaTransfer': this.downloadTransfer,
				},
				start_date: new Date(new Date().setMonth(new Date().getMonth() - 1)),
				end_date: new Date()
			}
		},
		methods: {
			/**
			 * Charge les lots générés sur la période choisie, prêts pour la table : dates en Date et
			 * statut traduit.
			 */
			async loadTransfers() {
				this.table_busy = true

				const transfers = await this.getSepaTransfers(this.start_date.toDateInputValue(), this.end_date.toDateInputValue())

				// Les dates voyagent en texte : la table ne les met en forme, et ne les trie, qu'en Date.
				this.transfers = transfers.map(transfer => ({
					...transfer,
					sepatransfer_generated_at: new Date(transfer.sepatransfer_generated_at),
					sepatransfer_execution_date: transfer.sepatransfer_execution_date ? new Date(transfer.sepatransfer_execution_date) : null,
					status_label: this.$t('invoice.sepa_history.statut.' + transfer.sepatransfer_status)
				}))

				this.table_busy = false
			},

			showTransfer(transfer) {
				this.$refs.detail.open(transfer.sepatransfer_id)
			},

			async downloadTransfer(transfer) {
				await this.downloadSepaTransferXml(transfer.sepatransfer_id)
				this.$refs.table.unselectAll()
			}
		},
		components: {
			DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2'),
			SepaTransferDetail: () => import('@/components/InvoiceSupplier/SepaTransferDetail'),
			CustomTable
		}
	}
</script>
